//JEENEETOpenBookCreatePage

import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBullseye, faCheckToSlot, faClock, faCopy, faEarth, faExclamationTriangle, faFileVideo, faHeartPulse, 
  faLightbulb, faListCheck, faLock, faMapLocation, faMicrochip, faMicrophone, faPen, faQrcode, faUpload
  } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import AILightComponent from '../../components/AILightComponent';

import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';

const JEENEETOpenBookCreatePage = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const [fetchData, { loading }] = useFetch();
  const { pageId } = useParams();
  const mode = pageId === undefined ? "add" : "update";
  const [openTextbook, setOpenBookPage] = useState(null);
  const { pageNumberList } = location.state || {};
  // console.log("Page Number List State: ",pageNumberList);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [showControls, setShowControls] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdateLock, setIsUpdateLock] = useState(false);
  
  const [isCheckedPageContentAISupport, setIsCheckedPageContentAISupport] = useState(false);
  const [isCheckedHiddenContentAISupport, setIsCheckedHiddenContentAISupport] = useState(false);

  const [formData, setFormData] = useState({
    userId: userId,
    userCode: userCode,
    userName: userName,
    bookId: '6703b08dd958602c3c46385b',   
    bookTitle: 'MOBook - Think5Whys DIY Open Text Book',
    pageNumber: 1,
    pageTitle: '',
    pageContent: '',
    isSplText: false,
    splText: '',
    readFromSplText: 0,
    hasVideo: 0,
    videoURL: '',
    searchTags: '',
    createdDate: new Date(),
    createdBy: userId,
    createdByName: userName,
    pageRemarks: '',
  });
  
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/useropenbookpages/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { pageId: pageId }
      };
  
      // console.log("Getting Data for Update here", config);
      // console.log("Existing formData", formData);
  
      fetchData(config, { showSuccessToast: false })
        .then((data) => {
          // console.log("response for update - ", data.pageData);
          setOpenBookPage(data.pageData);
          setFormData({
            userId: data.pageData.userId,
            userCode: data.pageData.userCode,
            userName: data.pageData.userName,
            bookId: data.pageData.bookId,   //6703b08dd958602c3c46385b
            bookTitle: data.pageData.bookTitle,
            pageNumber: data.pageData.pageNumber,
            pageTitle: data.pageData.pageTitle,
            pageContent: data.pageData.pageContent,
            isSplText: data.pageData.isSplText,
            splText: data.pageData.splText,
            readFromSplText: data.pageData.readFromSplText,
            hasVideo: data.pageData.hasVideo,
            videoURL: data.pageData.videoURL,
            searchTags: data.pageData.searchTags,
            createdDate: data.pageData.createdDate,
            createdBy: data.pageData.createdBy,
            createdByName: data.pageData.createdByName,
            pageRemarks: data.pageData.pageRemarks,
          });
        })
        .catch((error) => {
          console.error("Error fetching Open Book Page data:", error);
          setError("Error fetching Open Book Page data");
        });
    }
  }, [mode, authState, pageId, fetchData, setOpenBookPage]);
  

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  // const handleStartDateChange = (date) => {
  //   const isoDate = date ? date.toISOString() : '';
  //   setStartTime(isoDate);

  //   // Update formData state
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     startTime: isoDate,
  //   }));
  // };

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      pageNumber: pageData.pageNumber,
      pageTitle: pageData.pageTitle,
      pageContent: pageData.pageContent,
      isSplText: pageData.isSplText,
      splText: pageData.splText,
      readFromSplText: pageData.readFromSplText,
      hasVideo: pageData.hasVideo,
      videoURL: pageData.videoURL,
      searchTags: pageData.searchTags,
      pageRemarks: pageData.pageRemarks
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/useropenbookpages/save", 
        method: "post",
        data: {formData: formData, user: authState.user._id}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        navigate("/opentextbook-pagelist");
      });
    }
    else {
      const config = { 
        url: `/useropenbookpages/${pageId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" Open Text Book",config);

      fetchData(config).then(() => {
        navigate("/opentextbook-pagelist");
      })
      .catch((error) => {
        console.error("Error updating Open Book Page:", error);
        setError("Error updating Open Book Page");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.pageNumber) {
      errors.pageNumber = "Page Number is required";
    }
    if (!formData.pageTitle) {
      errors.pageTitle = "Page Title is required";
    } else if (formData.pageTitle.length > 200) {
      errors.pageTitle = "Page Title cannot exceed 2500 characters";
    }
    if (!formData.pageContent) {
      errors.pageContent = "Page Content is required";
    } else if (formData.pageContent.length > 3000) {
      errors.pageContent = "Page Content cannot exceed 2500 characters";
    }
    if (formData.splText.length > 2000) {
      errors.splText = "Hidden Content cannot exceed 2000 characters";
    }
    if (formData.videoURL.length > 200) {
      errors.videoURL = "URL cannot exceed 200 characters";
    }
    // if(mode === 'add') {
    //   if (pageNumberList.includes(formData.pageNumber)) {
    //     errors.pageOutOfBound = "Duplicate Page Not Allowed";
    //   }
    // }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleAddlCheckboxChange = (e) => {
    setAdditionalDataEntry(e.target.checked);
  };

  return (
    <>
      <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-gray-500 via-gray-600 to-gray-700 mt-12 rounded-lg">
        <h2 className='text-2xl font-bold text-white text-center mb-2'>My Own Open Text Book Page</h2>

{/* {pageNumberList && Array.isArray(pageNumberList) && pageNumberList.length > 0 ? (
  <ul>
    {pageNumberList.map((pageNumber, index) => (
      <li key={index}>
        {pageNumber},
      </li>
    ))}
  </ul>
) : (
  <p>No pages available</p>
)}             */}
          {loading ? (
              <Loader />
            ) : (
            <div className='text-sm'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Setup Page" : "Edit Page"}</h2>
              </div>
              <div className="border-container">
                <div className="mb-2 text-sm text-white">
                  <p>Page#*:</p>
                      <input 
                        type="number" 
                        name="pageNumber" 
                        id="pageNumber" 
                        min={1}
                        max={502}
                        step={1}
                        value={formData.pageNumber}
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          maxWidth: '100%', 
                          maxHeight: '100%' 
                        }}
                      />
                    {fieldError("pageNumber")}
                    <p>Page Title#*:</p>
                      <input 
                        type="text" 
                        name="pageTitle" 
                        id="pageTitle" 
                        value={formData.pageTitle}
                        onChange={handleChange}
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          maxWidth: '100%', 
                          maxHeight: '100%' 
                        }}
                      />
                    {fieldError("pageTitle")}
                    <p>Page Content* (Max 3000 Characters including formatting):</p>
                    <textarea 
                      type="pa" 
                      name="pageContent" 
                      id="pageContent" 
                      value={formData.pageContent}
                      onChange={handleChange}
                      maxLength="4000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '100%', 
                        maxHeight: '150px' 
                      }}
                    />
                  {fieldError("pageContent")}
                </div>
                <div className='w-6/12'>
                    <input 
                      type="checkbox" 
                      className="mr-2 cursor-pointer"
                      checked={isCheckedPageContentAISupport} 
                      onChange={() => setIsCheckedPageContentAISupport(!isCheckedPageContentAISupport)} 
                    />
                    <span className="text-lg font-medium text-white">Gen AI Support for Page Content</span>
                    <FontAwesomeIcon icon={faMicrochip} className="text-yellow-500 text-xl ml-3" />
                </div>
                {isCheckedPageContentAISupport && formData.pageContent!== '' && (
                  <div className="mb-1">
                    <AILightComponent param1={"Page Content"} param2={formData.pageContent}/>
                  </div>
                )}
               
                <div className="mb-2 mt-2 text-sm">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.isSplText} onChange={(e) => setFormData({ ...formData, isSplText: e.target.checked })} />
                    Want to Have Hidden Content for Listening
                  </label>
                </div>
                { formData.isSplText && (
                  <>
                  <div className="mb-2 text-sm">
                    <label htmlFor="splText">Hidden Content for Listening:</label>
                    <textarea 
                      type="text" 
                      name="splText" 
                      id="splText" 
                      value={formData.splText} 
                      placeholder="Enter hidden content to listen..."
                      onChange={handleChange} 
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '100%', 
                        maxHeight: '150px' 
                      }} 
                    />
                    {fieldError("splText")}
                  </div>
                  <div className='w-6/12'>
                    <input 
                      type="checkbox" 
                      className="mr-2 cursor-pointer"
                      checked={isCheckedHiddenContentAISupport} 
                      onChange={() => setIsCheckedHiddenContentAISupport(!isCheckedHiddenContentAISupport)} 
                    />
                    <span className="text-lg font-medium text-white">Gen AI Support for Background Content</span>
                    <FontAwesomeIcon icon={faMicrochip} className="text-yellow-500 text-xl ml-3" />
                  </div>
                  {isCheckedHiddenContentAISupport && formData.splText!== '' && (
                    <div className="mb-1">
                      <AILightComponent param1={"Background Content"} param2={formData.splText}/>
                    </div>
                  )}
                  <div className="mb-2 mt-2 text-sm">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.readFromSplText} onChange={(e) => setFormData({ ...formData, readFromSplText: e.target.checked ? 1 : 0 })} />
                      Listen Hidden Content (If not checked then you will hear page content)
                    </label>
                  </div>
                  </>
                )}
                
                <div className="mb-2 mt-2 text-sm">
                  <label>
                    <input className='mr-4' type="checkbox" checked={formData.hasVideo} onChange={(e) => setFormData({ ...formData, hasVideo: e.target.checked  ? 1 : 0 })} />
                    Want Page Default Video
                  </label>
                </div>
                { formData.hasVideo && (
                  <div className="mb-2 text-sm">
                    <label htmlFor="videoURL">Video URL:</label>
                    <input type="text" name="videoURL" id="videoURL" value={formData.videoURL} placeholder="Enter Video URL..."
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} />
                    {fieldError("videoURL")}
                  </div>
                )}
              </div>
              <div className="border-container-gray">
                <div className="mb-2 text-sm">
                  <label htmlFor="tags">Tags / Keyword:</label>
                  <br />
                  <input type="text" name="searchTags" id="searchTags" value={formData.searchTags} placeholder="Enter tags or keywords seperated by a comma (,) ..."
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '44px' }} />
                  {fieldError("searchTags")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="tags">Page Remarks:</label>
                  <br />
                  <input type="text" name="pageRemarks" id="pageRemarks" value={formData.pageRemarks} placeholder="Enter Page Remarks..."
                    onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '44px' }} />
                  {fieldError("pageRemarks")}
                </div>
              </div>
              
              <div className="border-container-gray">
                {/* <div className="border-container flex flex-col justify-center"> */}
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>

                  { mode == 'update' && (
                      <div>
                      <label>
                        <input 
                          className='mr-4' 
                          type="checkbox" 
                          checked={isUpdateLock} 
                          onChange={(e) => setIsUpdateLock(e.target.checked)} 
                        />
                        {isUpdateLock ? "Enable Update" : "Disable Update"}
                      </label>
                    </div>
                  )}
                  <div className="flex justify-center">
                    <button 
                      className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                      disabled={isUpdateLock && mode==="update"}
                      onClick={handleSubmit}>
                        {mode === "add" ? "Add New" : "Update"}
                    </button>
                    <button 
                      className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                      onClick={() => navigate("/opentextbook-pagelist")}>
                        Cancel
                    </button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
            </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default JEENEETOpenBookCreatePage;